import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import LoaderComp from "./Loader";
// Lazy-loaded components
const Home = lazy(() => import("../pages/Home"));
const Projects = lazy(() => import("../pages/Projects"));
const ProjectView = lazy(() => import("./ProjectView"));
const Teams = lazy(() => import("../pages/Teams"));
const Profile = lazy(() => import("../pages/Profile"));
const Contact = lazy(() => import("./contact"));
const Careers = lazy(() => import("./careers"));
const Publications = lazy(() => import("./Publications"));
const PublicationView = lazy(() => import("./PublicationView"));
const Journals = lazy(() => import("../pages/Journals"));
const JournalPost = lazy(() => import("../pages/JournalPost"));

const Body = (props) => {
  return (
    <div className='body-container'>
      <Suspense fallback={<LoaderComp />}>
        <Routes>
          <Route path='/' element={<Home {...props} />} />
          <Route path='/projects/:id' element={<ProjectView {...props} />} />
          <Route path='/project/:id' element={<ProjectView {...props} />} />
          <Route path='/projects' element={<Projects {...props} />} />
          <Route path='/profile' element={<Profile {...props} />} />
          <Route path='/team' element={<Teams {...props} />} />
          <Route path='/contact' element={<Contact {...props} />} />
          <Route path='/careers' element={<Careers {...props} />} />
          <Route path='/press' element={<Publications {...props} />} />
          <Route
            path='/press/:targetPath'
            element={<PublicationView {...props} />}
          />
          <Route path='/journals' element={<Journals {...props} />} />
          <Route path='/journals/:id' element={<JournalPost {...props} />} />
        </Routes>
      </Suspense>
    </div>
  );
};

export default Body;
